import brandmark from "@/assets/brandmark.png";
import LoginIcon from "@mui/icons-material/Login";
import { Alert, Box, Button, Paper, TextField, Typography } from "@mui/material";
import { type FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "./useAuth";

export function LoginPage() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await login(email, password);
      void nav("/", { replace: true });
    } catch (e) {
      setErr(e instanceof Error ? e.message : "Login failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Box
        sx={{ bgcolor: "primary.main", color: "primary.contrastText", px: 3, py: 2 }}
        display={"flex"}
        flexDirection={"row"}
        gap={1}
        alignItems={"center"}
      >
        <Box
          component="img"
          src={brandmark}
          alt=""
          sx={{ display: "block", width: { xs: 32, sm: 40 }, height: { xs: 32, sm: 40 } }}
        />

        <Typography
          variant="h6"
          noWrap
          sx={{ flex: 1, minWidth: 0, fontSize: { xs: "1.05rem", sm: "1.25rem" } }}
        >
          Staging Manager
        </Typography>
      </Box>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          pt: { xs: 4, sm: 8 },
          px: { xs: 2, sm: 0 },
        }}
      >
        <Paper
          component="form"
          onSubmit={(e) => void submit(e)}
          sx={{ p: { xs: 3, sm: 4 }, width: "100%", maxWidth: 360 }}
        >
          <Typography variant="h6" align="center" gutterBottom>
            Authentication
          </Typography>
          <TextField
            fullWidth
            required
            label="Email"
            type="email"
            autoComplete="username"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            fullWidth
            required
            label="Password"
            type="password"
            autoComplete="current-password"
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {err && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {err}
            </Alert>
          )}
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <Button type="submit" variant="contained" startIcon={<LoginIcon />} disabled={busy}>
              {busy ? "Signing in…" : "Login"}
            </Button>
          </Box>
        </Paper>
      </Box>
      <Typography variant="caption" sx={{ color: "primary.main", p: 1 }}>
        v 2.0.0 BETA
      </Typography>
    </Box>
  );
}
